import clsx from 'clsx';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import CommonCard from '../../Components/General/CommonCard';
import TimePickerInput from '../../Components/UI/TimePickerInput';
import { weeksDay } from '../../data';
import { defineTime } from '../../Schema';
import ModalAction from '../ModalAction';
import ModalSkeleton from '../ModalSkeleton';
import classes from './DefineAlertModal.module.css';
const initialValues = {
  startTime: '',
  endTime: ''
};
const DefineTimeAlertModal = ({ show, setShow, onSubmit, loading, width = '415px', data }) => {
  const [selectedDays, setSelectedDays] = useState([]);

  const onClose = () => {
    setShow(false);
    setSelectedDays([]);
    resetForm();
  };
  const formik = useFormik({
    initialValues,
    validationSchema: defineTime,
    onSubmit: (values, { resetForm }) => {
      const startTime = moment(values?.startTime, 'H:mm'); // Parse the first time
      const endTime = moment(values?.endTime, 'H:mm');
      const isBefore = endTime.isBefore(startTime);
      if (selectedDays?.length == 0) {
        return toast.error('Please Select date');
      }
      if (isBefore) {
        return toast.error('End time should be greater than start time');
      }
      const params = {
        ...(data && { doctorTimeId: data?.doctorTimeId }),
        days: selectedDays,
        timeFrom: moment(values?.startTime, 'HH:mm').utc().format('HH:mm:ss'),
        TimeTo: moment(values?.endTime, 'HH:mm').utc().format('HH:mm:ss'),
        timeZone: 'Asia/Karachi'
      };

      onSubmit(params, onClose);
    }
  });

  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;

  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const handleDaysInList = (data) => {
    setSelectedDays((currentState) => {
      if (currentState.includes(data)) {
        return currentState?.filter((day) => day != data);
      }
      return [...currentState, data];
    });
  };

  useEffect(() => {
    if (data) {
      const utcTime = moment.utc('2025-01-14T10:55:24');
      const pktTime = utcTime.tz('Asia/Karachi');
      const formattedTime = pktTime.format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)');
      setValues({
        startTime: moment
          .tz(data?.slot?.split(' - ')[0].replace(/\s/g, ''), 'Asia/Karachi')
          .toDate(),
        endTime: moment.tz(data?.slot?.split(' - ')[1].replace(/\s/g, ''), 'Asia/Karachi').toDate()
      });

      setSelectedDays(() => {
        return weeksDay
          ?.filter((element) => element?.value?.toLowerCase() === data?.day?.toLowerCase())
          ?.map((data) => data?.value);
      });
    }
  }, [data]);
  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);
  return (
    <ModalSkeleton
      padding={'12px 20px'}
      gapBetweenHeadAndBody="8px"
      borderRadius="8px"
      width={width}
      title={''}
      show={show}
      position="top"
      setShow={onClose}>
      <h3 className={classes.clinicHeading}>Clinic Time</h3>
      <form onSubmit={handleSubmit}>
        <Row className={classes.controlGrid}>
          <Col sm={12}>
            <TimePickerInput
              setter={(e) => {
        
                handleChangeWithTouch('startTime', e);
              }}
              value={values?.startTime}
              label={'Sart Time'}
            />
          </Col>
          <Col sm={12}>
            <TimePickerInput
              label={'Close Time'}
              setter={(e) => handleChangeWithTouch('endTime', e)}
              value={values?.endTime}
            />
          </Col>
        </Row>
        <menu className={classes.selectedDayWrapper}>
          {weeksDay?.map((data) => (
            <CommonCard
              onClick={() => {
                handleDaysInList(data?.value);
              }}
              loading={loading}
              key={data?.id}
              Tag="button"
              type="button"
              className={clsx(classes.weekSelectWrapper, 'transparent-button', {
                [classes.shine]: selectedDays.includes(data?.value)
              })}>
              <span className={classes.weekName}>{data?.label}</span>
            </CommonCard>
          ))}
        </menu>
        <ModalAction type="submit" className={classes.actions} isApiCall={loading} />
      </form>
    </ModalSkeleton>
  );
};

export default DefineTimeAlertModal;
